// extracted by mini-css-extract-plugin
export default {"success":"order_success__JmCHl","Order_Div":"order_Order_Div__gnfsO","User":"order_User__KlhIT","Order":"order_Order__f5Flp","TableBody":"order_TableBody__OjrQj"};